import BaseLine, { IEndInfo } from '../line-base';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';

class StraightLine1 extends BaseLine {
    public svgPathInRect = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        let startPos;
        let endPos;
        if (w < 1e-4) {
            startPos = {
                x,
                y: y + endInfo.head,
            };
            endPos = {
                x: x + w,
                y: y + h - endInfo.tail,
            };
        } else if (h < 1e-4) {
            startPos = {
                x: x + endInfo.head,
                y,
            };
            endPos = {
                x: x + w - endInfo.tail,
                y: y + h,
            };
        } else {
            const p1 = { x, y };
            const p2 = { x: x + w, y: y + h };
            const l = Graphic.lengthBetweenTwoPoints(p1, p2);
            startPos = {
                x: x + (endInfo.head * w / l),
                y: y + (endInfo.head * h / l),
            };
            endPos = {
                x: x + w - (endInfo.tail * w / l),
                y: y + h - (endInfo.tail * h / l),
            };
        }

        return `M${startPos.x} ${startPos.y} L${endPos.x} ${endPos.y}`;
    };

    public setLineInfo = (x: number, y: number, w: number, h: number, controlValues: number[], endInfo: IEndInfo) => {
        if (w < 1e-4) {
            this.startPos = {
                x,
                y: y + endInfo.head,
            };
            this.endPos = {
                x: x + w,
                y: y + h - endInfo.tail,
            };
        } else if (h < 1e-4) {
            this.startPos = {
                x: x + endInfo.head,
                y,
            };
            this.endPos = {
                x: x + w - endInfo.tail,
                y: y + h,
            };
        } else {
            const p1 = { x, y };
            const p2 = { x: x + w, y: y + h };
            const l = Graphic.lengthBetweenTwoPoints(p1, p2);
            this.startPos = {
                x: x + (endInfo.head * w / l),
                y: y + (endInfo.head * h / l),
            };
            this.endPos = {
                x: x + w - (endInfo.tail * w / l),
                y: y + h - (endInfo.tail * h / l),
            };
        }
    };
}

export default StraightLine1;
